import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom styled switch to make it look "Premium"
const Android12Switch = styled(Switch)(() => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export const IsDefaultToggle = ({ checked, onChange, inputProps }) => {
  return (
    <Android12Switch
      {...inputProps}
      checked={checked}
      onChange={onChange}
      // Stop the click from bubbling up to the TableRow
      onClick={(e) => e.stopPropagation()}
      color="success" 
    />
  );
};